/**
 * Typed Redux hooks.
 *
 * Use `useAppDispatch` and `useAppSelector` everywhere instead of plain
 * `useDispatch` / `useSelector` so dispatch + state shape are correctly
 * typed. Uses the Redux Toolkit v2 `.withTypes<...>()` syntax which is
 * the template convention.
 */
import { useDispatch, useSelector } from "react-redux";

import type { AppDispatch, RootState } from "./index";

/** Typed useDispatch - use instead of the plain react-redux hook. */
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
/** Typed useSelector - use instead of the plain react-redux hook. */
export const useAppSelector = useSelector.withTypes<RootState>();
